import { MenuMode } from '../../../../menuModeConstants';
import type { PositionUpdaters } from './types';
import { getCss, setCss, clearCss } from './helpers';
import { setVerticalPosition } from './setVerticalPosition';

export const createDepth0PositionUpdaters_column =
  (menuMode: MenuMode): PositionUpdaters =>
  ({ label, positionBox }) => ({
    onEnter: () => {
      if (menuMode === 'wrap') {
        const labelShift = getCss(label, 'margin-top');
        setCss(positionBox, 'transform', `translateY(-${labelShift})`);
      }

      setVerticalPosition({ label, positionBox }, 'column');
    },
    onLeave: () => {
      clearCss(positionBox);
      clearCss(positionBox.firstChild as HTMLElement);
    },
  });
